import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { JOIN_CLASS_PARAM } from '@examdojo/class';
import { ErrorHandlerService } from '@examdojo/core/error-handling';
import { catchError, map, of } from 'rxjs';
import { StudentClassService } from '../student-class/student-class.service';
import { ClassLimitReachedDialogService } from './class-limit-reached/class-limit-reached-dialog.service';
import { isClassLimitReachedError } from './class-limit-reached/class-limit-reached.utils';

export const forceJoinClassGuard: CanActivateFn = (route) => {
  const code = route.queryParams[JOIN_CLASS_PARAM];

  if (!code) {
    return true;
  }

  const studentClassService = inject(StudentClassService);
  const router = inject(Router);
  const errorHandlerService = inject(ErrorHandlerService);
  const classLimitReachedDialogService = inject(ClassLimitReachedDialogService);

  return studentClassService.joinClass(code).pipe(
    map((result) => {
      if (!result) {
        return router.createUrlTree(['/classes']);
      }

      const slug = studentClassService.buildSlug(result.name, result.id);
      return router.createUrlTree(['/classes', slug]);
    }),
    catchError((error: unknown) => {
      if (isClassLimitReachedError(error)) {
        classLimitReachedDialogService.open();
        return of(router.createUrlTree(['/classes']));
      }
      throw error;
    }),
    errorHandlerService.catchError(
      `[ForceJoinClassGuard.joinClass]: failed to join class`,
      () => of(router.createUrlTree(['/classes'])),
      {
        toast: (err) => ({
          title: 'An error occurred while joining the class',
          description: (err as Error)?.message,
        }),
      },
    ),
  );
};
